import { DependencyList, useCallback, useEffect, useRef } from 'react'

function useThrottledCallback(callback: (...args: any[]) => any, wait: number, deps: DependencyList) {
  const blockedRef = useRef(false)
  const timeoutRef = useRef<number | null>(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  return useCallback(
    (...args: any[]) => {
      if (blockedRef.current) {
        console.log('WARN: function call throttled')
        return
      }

      blockedRef.current = true
      timeoutRef.current = setTimeout(() => {
        blockedRef.current = false
        timeoutRef.current = null
      }, wait)

      return callback(...args)
    },
    [callback, wait],
  )
}

export default useThrottledCallback
